/**
 * Module-scoped in-memory access-token store. The access token is a
 * short-lived WorkOS JWT — keeping it in JS memory (never `localStorage`)
 * limits an XSS-derived exfiltration to whatever lives in this tab right
 * now. The refresh-token cookie at `api.immoos.ai` is unreachable from JS
 * and survives a tab close, so a reload re-mints a new access token via
 * `/auth/refresh` without a redirect.
 *
 * Subscribers exist for components (or the root loader) that want to react
 * to sign-in / sign-out without polling. No persistence on purpose.
 */

type Listener = (token: string | null) => void;

let token: string | null = null;
const listeners = new Set<Listener>();

export function getAccessToken(): string | null {
  return token;
}

export function setAccessToken(next: string | null): void {
  if (next === token) {
    return;
  }

  token = next;

  for (const listener of listeners) {
    listener(token);
  }
}

export function subscribeAccessToken(listener: Listener): () => void {
  listeners.add(listener);

  return () => listeners.delete(listener);
}
